$(document).ready(function () {
    'use strict';

    $('.close').click(function(){
        $(this).parents('.alert-danger').addClass('hidden');
    });
});
